export function facebookTrackCustom(pixelId: string, eventName: string, eventProps?: { [key: string]: string | number | boolean }) {
  const fbq = window.fbq
  if (!fbq) return
  fbq('trackSingleCustom', pixelId, eventName, eventProps)
}
